import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  
  public finished = true;
  public menus = [
    { id: 'distribution-vs-atendance', label: 'Distribuição x atendimento', path: 'distribuicao-atendimento' },
    { id: 'distribution-by-broker', label: 'Distribuição por corretor', path: 'distribuicao-corretor' },
    { id: 'impounded-leads', label: 'Leads represados', path: 'leads-represados' }
  ];

  constructor(private router: Router) { }

  get hasFinishedLoading(): boolean {
    return this.finished;
  }

  ngOnInit(): void {
    const paths = this.router.url.split('/').filter(el => el);
    if (paths.length === 1) {
      this.router.navigate(['relatorios-de-distribuicao/distribuicao-atendimento']);
    }
  }

  public isCurrentRoute(path: string): boolean {
    const [, , currentPath] = window.location.pathname.split('/');
    if (currentPath) {
      return currentPath.includes(path);
    }
    return false;
  }
}
